import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Device } from '../../../shared/interfaces/click.interfaces';
import { Observable } from 'rxjs';
import { DeviceAdd, LinkedDeviceGetResponse, LinkedDevicesListGetResponse } from '../../../shared/interfaces/account.interfaces';

const basePath = '/account/click';

@Injectable({
  providedIn: 'root',
})

export class AccountClickService {
  constructor(private http: HttpClient) { }

  // Search for a device by it's user email
  searchDevice(email: string): Observable<Device> {
    return this.http.get<Device>(`${basePath}/find/${email}`);
  }

  // Get all devices linked to a given account
  getAccountDevices(accountId: number | string | undefined): Observable<LinkedDevicesListGetResponse> {
    return this.http.get<LinkedDevicesListGetResponse>(`${basePath}/${accountId}`);
  }

  // Adds a click device to an account
  addDevice(payload: DeviceAdd): Observable<LinkedDevicesListGetResponse> {
    const body = {
      uid: payload.uid,
      template: payload.template
    };
    return this.http.post<LinkedDevicesListGetResponse>(`${basePath}/${payload.accountId}`, body);
  }

  // Get details of a device linked to a given account
  getDeviceByFirebaseUid(accountId: number, firebaseUid: string): Observable<LinkedDeviceGetResponse> {
    return this.http.get<LinkedDeviceGetResponse>(`${basePath}/${accountId}/${firebaseUid}`);
  }

  // Remove a click device from an account
  removeDeviceFromAccount(accountId: number, firebaseUid: string) {
    return this.http.delete(`${basePath}/${accountId}/${firebaseUid}`);
  }

}
